import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoaderService } from '../../services/loader.service';

/** Key used to tell whether the current language's translation file has been loaded. */
export const LOADER_TAGLINE_KEY = 'unifiedComponents.loaderTagline';

@Component({
  selector: 'app-custom-loader',
  templateUrl: './custom-loader.component.html',
  styleUrls: ['./custom-loader.component.scss']
})
export class CustomLoaderComponent {
  constructor(public loader: LoaderService, private translate: TranslateService) { }

  /**
   * The overlay paints before ngx-translate has fetched `assets/translate/<lang>.json`; until then `instant()`
   * echoes the key, so the texts stay hidden and only the logo shows instead of raw translation keys.
   */
  get translationsReady(): boolean {
    return this.translate.instant(LOADER_TAGLINE_KEY) !== LOADER_TAGLINE_KEY;
  }
}
